import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Rutas donde un 401 es una respuesta esperada (credenciales o enlace invalidos), no una sesion vencida.
const RUTAS_SIN_SESION = ['/api/usuario/login', '/api/usuario/restore'];

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // console.log('interceptando');

        const token = localStorage.getItem('currentUser');
        if (!token) {
            return next.handle(req);
        }
        const headers = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${token}`)
        });
        return next.handle(headers).pipe(
            catchError((error: HttpErrorResponse) => {
                // Sesion vencida o invalida: se limpia y se vuelve al login
                if (error.status === 401 && !RUTAS_SIN_SESION.some(ruta => req.url.indexOf(ruta) !== -1)) {
                    localStorage.removeItem('currentUser');
                    localStorage.removeItem('lastLogin');
                    window.location.href = '/login';
                }
                return throwError(error);
            })
        );
    }
}
